import { useCallback, useMemo } from 'react';
import dna from '~/assets/icons/dna.svg';
import {
	PropertyContainer,
	PropertyContainerRow,
} from '~/components/ui/PropertyContainer';
import { SelectItem } from '~/components/ui/SelectItem';
import { Slider } from '~/components/ui/Slider';
import { Text } from '~/components/ui/Text';
import { Gender } from '~/shared';
import {
	setParentsValue,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import { parentsImages } from '../Parent';
import { Section } from '../Section';
import { SectionHeading } from '../SectionHeading';
import {
	StyledContainer,
	StyledParentsPreviewContainer,
} from './DNATab.styled';

const DNATab: React.FC = () => {
	const dispatch = useLayoutDispatch();
	const parentsValue = useLayoutSelector(
		(state) => state.characterEditor.parentsValue,
	);
	// @TODO
	// const parentConfigValues = useObservable(
	// 	rage.characterEditor.getParentConfigs(),
	// );
	const parentConfigValues: any[] = [];

	const parent1 = useMemo(
		() => parentsImages[parentsValue.momIndex],
		[parentsValue],
	);
	const parent2 = useMemo(
		() => parentsImages[parentsValue.dadIndex],
		[parentsValue],
	);

	const handleSelectParent = useCallback(
		async (index: number, gender: Gender) => {
			if (gender === Gender.MALE) {
				dispatch(setParentsValue({ ...parentsValue, dadIndex: index }));
				// @TODO СДК редиктировния персонажа
				// await rage.characterEditor.setParentsValue({
				// 	...parentsValue,
				// 	dadIndex: index,
				// });
				return;
			}

			dispatch(setParentsValue({ ...parentsValue, momIndex: index }));
			// @TODO СДК редиктировния персонажа
			// await rage.characterEditor.setParentsValue({
			// 	...parentsValue,
			// 	momIndex: index,
			// });
		},
		[parentsValue],
	);

	const handleSetFaceBlend = useCallback(
		async (value: number) => {
			dispatch(setParentsValue({ ...parentsValue, faceBlend: value }));
			// await rage.characterEditor.setParentsValue({
			// 	...parentsValue,
			// 	faceBlend: value,
			// });
		},
		[parentsValue],
	);

	const handleSetSkinBlend = useCallback(
		async (value: number) => {
			dispatch(setParentsValue({ ...parentsValue, skinBlend: value }));
			// @TODO СДК редиктировния персонажа
			// await rage.characterEditor.setParentsValue({
			// 	...parentsValue,
			// 	skinBlend: value,
			// });
		},
		[parentsValue],
	);

	return (
		<StyledContainer>
			<StyledParentsPreviewContainer>
				<img src={parent1} className={'parent1'} />
				<img src={parent2} className={'parent2'} />
			</StyledParentsPreviewContainer>
			<Section>
				<SectionHeading icon={dna} text={'Генетика'} />
				<PropertyContainer>
					<PropertyContainerRow>
						<Text>Ген 1</Text>
						<SelectItem
							items={parentConfigValues.map((item) => ({
								value: item.index,
								title: item.name,
							}))}
							value={{
								value: parentsValue.momIndex,
								title:
									parentConfigValues.find(
										(item) => item.index === parentsValue.momIndex,
									)?.name || '',
							}}
							onChange={(value) =>
								handleSelectParent(value.value, Gender.FEMALE)
							}
							loop
						/>
					</PropertyContainerRow>
					<PropertyContainerRow>
						<Text>Ген 2</Text>
						<SelectItem
							items={parentConfigValues.map((item) => ({
								value: item.index,
								title: item.name,
							}))}
							value={{
								value: parentsValue.dadIndex,
								title:
									parentConfigValues.find(
										(item) => item.index === parentsValue.dadIndex,
									)?.name || '',
							}}
							onChange={(value) => handleSelectParent(value.value, Gender.MALE)}
							loop
						/>
					</PropertyContainerRow>
					<PropertyContainerRow>
						<Text>Схожесть</Text>
						<Slider
							value={parentsValue.faceBlend}
							onChange={handleSetFaceBlend}
							valueInput
							center
						/>
					</PropertyContainerRow>
					<PropertyContainerRow>
						<Text>Цвет кожи</Text>
						<Slider
							value={parentsValue.skinBlend}
							onChange={handleSetSkinBlend}
							valueInput
							center
						/>
					</PropertyContainerRow>
				</PropertyContainer>
			</Section>
		</StyledContainer>
	);
};

export { DNATab };
